export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13808.075a512f.jpg";